import Vue from "vue";
import Vuetify from "vuetify/lib";
import colors from "vuetify/lib/util/colors";
import "@mdi/font/css/materialdesignicons.css"; // Ensure you are using css-loader

//Import our store folder, in store/index.js we set up out state management
import store from "../store";

Vue.use(Vuetify);

//Check our dark theme setting here
const darkTheme = store.getters.retrieveDarkTheme;

const vuetify = new Vuetify({
  theme: {
    options: {
      customProperties: true,
    },
    icons: {
      iconfont: "mdi", // default - only for display purposes
    },
    dark: darkTheme,
    themes: {
      dark: {
        primary: store.getters.retrievePrimaryBg,
        accent: "#FF4081",
        secondary: colors.blue.darken2,
        success: "#4CAF50",
        info: "#2196F3",
        warning: "#FB8C00",
        error: "#FF5252",
        // anchor: "#DADADA",

        favourites: colors.pink.base,
        promotions: colors.yellow.darken3,

        color: "#FFF",
        color_off: "#9da1ab",

        // background: "#1f2227",
        // background_alt: "#1f2227",
        // background_off: "#1f2227",
        // footerColor: "#1f2227",

        background: "#171717",
        background_alt: "#171717",
        background_off: "#1d1d1d",
        footerColor: "#171717",

        menu_color: store.getters.retrieveMenuColor,
        menu_icon: store.getters.retrieveMenuIcon,
        menu_border_color: colors.grey.darken2,

        scrollbarBackground: "#0a0a0a",
        scrollbarThumb: "#556167",
      },

      light: {
        primary: store.getters.retrievePrimaryBg,
        accent: "#e91e63",
        secondary: colors.blue.darken2,
        success: "#4CAF50",
        info: "#2196F3",
        warning: "#FB8C00",
        error: "#FF5252",
        // anchor: "#565656",

        favourites: colors.pink.base,
        promotions: colors.yellow.darken3,

        color: "#373e4c",
        color_off: "#434a58",

        // background: "#f7fafc",
        background: colors.shades.white,
        background_alt: colors.shades.white,
        background_off: "#F4F4F5",
        footerColor: colors.shades.white,

        menu_color: store.getters.retrieveMenuColor,
        menu_icon: store.getters.retrieveMenuIcon,
        menu_border_color: colors.grey.lighten2,

        scrollbarBackground: "#CFD8DC",
        scrollbarThumb: "#90A4AE",
      },
    },
  },
});

export default vuetify;
